import { createContext } from 'react';

const DatastoreContext = createContext(
    null // default value (initialised on first use in root.jsx)
);

export default DatastoreContext;